var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv3.jpg",
      "video": "/images/sub/visual/sv3.mp4"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-bold"
  }, [_vm._v("제휴문의")])])])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 풍부한 경험과 글로벌 네트워크를 바탕으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 고객사의 브랜드를 강화합니다. ")])]), _c('h5', {
    staticClass: "tit-txt pb-2 border-bottom border-2 border-lg-4 border-color-point mx-auto mb-50 mb-lg-74",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v("신규사업 제휴 절차")]), _c('div', {
    staticClass: "steps mx-sm-auto",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_c('div', {
    staticClass: "step d-md-flex align-start pb-20 pb-lg-50"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0"
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(" STEP 01 ")]), _c('span', {
    staticClass: "step__point mr-6 mr-md-0"
  })]), _c('div', {
    staticClass: "ml-md-24 ml-lg-60",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 미팅 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mt-2 mt-lg-0"
  }, [_vm._v(" 고객사의 단기·장기 목표 확인 후, 세일즈 솔루션과 성장 전략 제시 ")])])]), _c('div', {
    staticClass: "step d-md-flex align-start pb-20 pb-lg-50"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0"
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(" STEP 02 ")]), _c('span', {
    staticClass: "step__point mr-6 mr-md-0"
  })]), _c('div', {
    staticClass: "ml-md-24 ml-lg-60",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 테스트 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mt-2 mt-lg-0"
  }, [_vm._v(" 테스트 캠페인을 통해 시장 가능성 확인 ")])])]), _c('div', {
    staticClass: "step d-md-flex align-start pb-20 pb-lg-50"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0"
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(" STEP 03 ")]), _c('span', {
    staticClass: "step__point mr-6 mr-md-0"
  })]), _c('div', {
    staticClass: "ml-md-24 ml-lg-60",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 개발 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mt-2 mt-lg-0"
  }, [_vm._v(" 테스트 결과를 반영하여 캠페인 운영 절차 수립 ")])])]), _c('div', {
    staticClass: "step d-md-flex align-start"
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0"
  }, [_c('p', {
    staticClass: "page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(" STEP 04 ")]), _c('span', {
    staticClass: "step__point mr-6 mr-md-0"
  })]), _c('div', {
    staticClass: "ml-md-24 ml-lg-60",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 고객사 관리 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mt-2 mt-lg-0"
  }, [_vm._v(" 캠페인 결과에 대한 분석 및 보고 후, 정식 런칭 및 장기 파트너십 구축 ")])])])])])], 1), _c('section', {
    staticClass: "section text-center",
    staticStyle: {
      "background-image": "url(/images/sub/affiliate/banner.jpg)"
    }
  }, [_c('v-container', [_c('h4', {
    staticClass: "tit color-white mb-12 mb-lg-24",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 세일즈웍스는 "), _c('br'), _vm._v(" 다양한 사업 파트너와의 협업을 기대하고 있습니다. ")]), _c('div', {
    staticClass: "d-flex flex-column flex-sm-row justify-center align-center color-grey-d",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('a', {
    staticClass: "d-block tit-txt",
    attrs: {
      "href": "mailto:info@salesworks.asia",
      "target": "_blank"
    }
  }, [_vm._v("info@salesworks.asia")]), _c('span', {
    staticClass: "line mx-12 mx-lg-20 d-none d-sm-block"
  }), _c('a', {
    staticClass: "d-block tit-txt mt-4 mt-sm-0",
    attrs: {
      "href": "tel:1600-3939"
    }
  }, [_vm._v("1600-3939")])])])], 1), _c('section', {
    staticClass: "section bg-grey"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(" 세계를 무대로 25년 이상 쌓아온 전문성이 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 결과의 차이를 만듭니다. ")])]), _c('div', {
    staticClass: "mb-50 mb-lg-80"
  }, [_c('v-row', {
    staticClass: "flex-column-reverse flex-md-row"
  }, [_c('v-col', {
    staticClass: "d-md-flex flex-md-column justify-md-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "5",
      "xl": "4",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "under-line mb-16 mb-lg-30 pb-18 pb-lg-34"
  }, [_c('h3', {
    staticClass: "tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v("01")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 최적화된 영업망 ")])]), _c('p', {
    staticClass: "dot-text mb-4 mb-lg-14"
  }, [_vm._v(" 전국 주요 도시에 지점을 운영하여 지역에 제한 없는 전문 인재 파견이 가능합니다. ")]), _c('p', {
    staticClass: "dot-text"
  }, [_vm._v(" 추가 비용 없이 영업 규모를 유동적으로 조정하고 확장할 수 있습니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "7",
      "offset-xl": "1",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/affiliate/s2-img1.jpg"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mb-50 mb-lg-80 text-lg-right"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "7",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/affiliate/s2-img2.jpg"
    }
  })], 1), _c('v-col', {
    staticClass: "d-md-flex flex-md-column justify-md-center align-lg-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "5",
      "xl": "4",
      "offset-xl": "1",
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "under-line mb-16 mb-lg-30 pb-18 pb-lg-34"
  }, [_c('h3', {
    staticClass: "tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v("02")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 세일즈 전문성 ")])]), _c('p', {
    staticClass: "dot-text mb-4 mb-lg-14"
  }, [_vm._v(" 아시아 8개국에서 25년 이상 쌓은 경험과 노하우로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고객사의 영업을 대행합니다. ")]), _c('p', {
    staticClass: "dot-text"
  }, [_vm._v(" 홍보를 통해 잠재 고객을 확보하고 시장의 규모를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 확대합니다. ")])])], 1)], 1), _c('div', {
    staticClass: "mb-50 mb-lg-80"
  }, [_c('v-row', {
    staticClass: "flex-column-reverse flex-md-row"
  }, [_c('v-col', {
    staticClass: "d-md-flex flex-md-column justify-md-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "5",
      "xl": "4",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "under-line mb-16 mb-lg-30 pb-18 pb-lg-34"
  }, [_c('h3', {
    staticClass: "tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v("03")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 솔루션 제공 ")])]), _c('p', {
    staticClass: "dot-text mb-4 mb-lg-14"
  }, [_vm._v(" 보다 나은 영업 실적을 원하는 기업의 영업을 대행합니다. ")]), _c('p', {
    staticClass: "dot-text"
  }, [_vm._v(" 타겟 고객층에 대한 철저한 분석과 평가를 통해 비용 대비 최적의 효과를 도출합니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "7",
      "offset-xl": "1",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/affiliate/s2-img3.jpg"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "text-lg-right"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "7",
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/affiliate/s2-img4.jpg"
    }
  })], 1), _c('v-col', {
    staticClass: "d-md-flex flex-md-column justify-md-center align-lg-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "5",
      "xl": "4",
      "offset-xl": "1",
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "under-line mb-16 mb-lg-30 pb-18 pb-lg-34"
  }, [_c('h3', {
    staticClass: "tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v("04")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold"
  }, [_vm._v(" 영업 인재 관리 ")])]), _c('p', {
    staticClass: "dot-text mb-4 mb-lg-14"
  }, [_vm._v(" 브랜드 홍보대사 그리고 펀드레이저에게 지속적으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전문 교육을 진행합니다. ")]), _c('p', {
    staticClass: "dot-text"
  }, [_vm._v(" 세일즈웍스의 인재들은 전문성과 경쟁력을 갖춘 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 업계 최고의 전문가입니다. ")])])], 1)], 1)])], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 세일즈웍스 코리아는 고객을 가장 먼저 생각합니다. ")])]), _c('h5', {
    staticClass: "bar-text mb-30 mb-lg-24"
  }, [_vm._v(" 브랜드 약속 ")]), _c('div', {
    staticClass: "border border-color-light"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-20 pa-md-30 py-lg-58 d-flex flex-column align-center text-center border-bottom border-md-bottom-0 border-md-end border-color-light",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-img', {
    staticClass: "mb-10 mb-lg-18",
    attrs: {
      "src": "/images/sub/affiliate/s3-icon1.png",
      "contain": "",
      "max-width": "53",
      "data-aos": "fade-down"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold mb-4 mb-lg-8",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 안정적인 고객 유치 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 보다 나은 영업 실적을 원하는 기업 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 또는 전문 영업팀이 없는 스타트업 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 등에 정확한 타겟 전략으로 맞춤형 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 솔루션을 제공합니다. ")])], 1), _c('v-col', {
    staticClass: "pa-20 pa-md-30 py-lg-58 d-flex flex-column align-center text-center border-bottom border-md-bottom-0 border-md-end border-color-light",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-img', {
    staticClass: "mb-10 mb-lg-18",
    attrs: {
      "src": "/images/sub/affiliate/s3-icon2.png",
      "contain": "",
      "max-width": "56",
      "data-aos": "fade-down"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold mb-4 mb-lg-8",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 브랜드 강화 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 세일즈웍스는 고객 유치는 물론, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 잠재고객 한 명 한 명에게 맞춤형 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 홍보를 하며 긍정적인 이미지를 남기고 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 브랜드의 인지도를 높입니다. ")])], 1), _c('v-col', {
    staticClass: "pa-20 pa-md-30 py-lg-58 d-flex flex-column align-center text-center",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-img', {
    staticClass: "mb-10 mb-lg-18",
    attrs: {
      "src": "/images/sub/affiliate/s3-icon3.png",
      "contain": "",
      "max-width": "60",
      "data-aos": "fade-down"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold mb-4 mb-lg-8",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 투자수익률 보장 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 세일즈웍스는 달성한 실제 성과에만 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 비용을 부과합니다. 따라서 고객사는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 투자수익률을 보장하고 리스크없이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 안정적인 고객 확보가 가능합니다. ")])], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }